module.exports = __webpack_public_path__ + "static/media/heron.77dedf8c.jpg";